import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { TextField } from 'mui-rff';
import { Form } from 'react-final-form';
import { Avatar, Button, Typography, Container, Box } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useSnackbar } from 'notistack';
import { styled } from '@mui/material/styles';
//
import { userApi, useSignInMutation } from '../../../store/api/user.api';
import { signIn } from '../../../store/slice/auth.slice';

const StyledForm = styled('form')(({ theme }) => ({
  width: '100%', // Fix IE 11 issue.
  marginTop: theme.spacing(1),
}));

export default function SignIn() {
  const { enqueueSnackbar } = useSnackbar();
  const [login] = useSignInMutation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onSubmit = useCallback(
    async (values) => {
      try {
        const { token, user } = await login(values).unwrap();
        dispatch(signIn(token));
        // pure QoL - we already have data, might as well pre-populate cache to skip extra request
        dispatch(
          userApi.util.upsertQueryData('getCurrentUser', undefined, user),
        );
        navigate('/');
      } catch (err) {
        const rawMessage =
          err?.response?.data?.message ||
          err?.response?.data ||
          err.message ||
          'Failed to sign in';
        const errorMessage =
          err.status === 401 ? 'Invalid login or password' : rawMessage;
        enqueueSnackbar(errorMessage, { variant: 'error' });
      }
    },
    [dispatch, login, enqueueSnackbar, navigate],
  );

  const validate = useCallback((values) => {
    const errors = {};
    if (!values.email) {
      errors.email = 'Required';
    }
    if (!values.password) {
      errors.password = 'Required';
    }
    return errors;
  }, []);

  return (
    <Container component='main' maxWidth='xs'>
      <Box display='flex' flexDirection='column' mt={14} alignItems='center'>
        <Avatar sx={{ m: 1, backgroundColor: 'secondary' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component='h1' variant='h5'>
          Sign in
        </Typography>
        <Form
          onSubmit={onSubmit}
          validate={validate}
          render={({ handleSubmit, submitting }) => (
            <StyledForm onSubmit={handleSubmit} noValidate>
              <TextField
                variant='outlined'
                margin='normal'
                required
                fullWidth
                id='email'
                label='Email Address'
                name='email'
                autoComplete='email'
                autoFocus
              />
              <TextField
                variant='outlined'
                margin='normal'
                required
                fullWidth
                name='password'
                label='Password'
                type='password'
                id='password'
                autoComplete='current-password'
              />
              <Button
                type='submit'
                fullWidth
                variant='contained'
                color='primary'
                loading={submitting}
                sx={{ mt: 3, mb: 2 }}
              >
                Sign In
              </Button>
            </StyledForm>
          )}
        />
      </Box>
    </Container>
  );
}
